import { visserApi } from './visserApi';
const login = (credentials) => {
    return visserApi.post('account/authenticate', credentials);
};
const getRefreshToken = (refreshToken) => {
    return visserApi.post('token/refresh', refreshToken);
};
const verifyToken = (refreshToken) => {
    return visserApi.post('account/verify-token', refreshToken);
};
const signUp = (user) => {
    return visserApi.post('account/register', user);
};
const confirmEmail = (confirmation) => {
    return visserApi.post('account/email-confirmation', confirmation);
};
const forgotPassword = (input) => {
    return visserApi.post('account/forgot-password', input);
};
const changePassword = (input) => {
    return visserApi.post('account/ChangePassword', input);
};
const getAllEmployees = async () => {
    return await visserApi.get('account/GetAllEmployees');
};
const getUserById = async (id) => {
    return await visserApi.get(`account/GetUserById/${id}`);
};
const getAllUserRoles = async () => {
    return await visserApi.get('account/GetAllRoles');
};
const createUser = async (createUser) => {
    return await visserApi.post('account/RegisterEmployee', createUser);
};
const updateUser = async (updateUser) => {
    return await visserApi.post('account/UpdateEmployee', updateUser);
};
const updateEmployeeStatus = async (updateEmployeeStatus) => {
    return await visserApi.post('account/UpdateEmployeeStatus', updateEmployeeStatus);
};
const updateRoleStatus = async (updateRoleStatus) => {
    return await visserApi.post('account/UpdateRoleStatus', updateRoleStatus);
};
const resetPassword = (input) => {
    return visserApi.post('account/ResetPassword', input);
};
const getWorkshopLocation = async () => {
    return await visserApi.get('workshoplocation/GetAll');
};
const getEmployeesByRoleCategory = async () => {
    return await visserApi.get('account/getEmployeesByRoleCategory');
};
const getEmployeeSettingsByEmployeeId = async (id) => {
    return await visserApi.get(`account/GetEmployeeSettingsByEmployeeId/${id}`);
};
const createEmployeeSettings = async (createEmployeeSetting) => {
    return await visserApi.post('account/CreateEmployeeSettings', createEmployeeSetting);
};
const AuthApi = {
    login,
    getRefreshToken,
    signUp,
    confirmEmail,
    forgotPassword,
    changePassword,
    verifyToken,
    getAllEmployees,
    getUserById,
    getAllUserRoles,
    createUser,
    updateUser,
    updateRoleStatus,
    updateEmployeeStatus,
    resetPassword,
    getWorkshopLocation,
    getEmployeesByRoleCategory,
    getEmployeeSettingsByEmployeeId,
    createEmployeeSettings
};
export default AuthApi;
